import { render, staticRenderFns } from "./uploadfarmers.vue?vue&type=template&id=4065e3ea"
import script from "./uploadfarmers.vue?vue&type=script&lang=js"
export * from "./uploadfarmers.vue?vue&type=script&lang=js"
import style0 from "./uploadfarmers.vue?vue&type=style&index=0&id=4065e3ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports